import { render, staticRenderFns } from "./goods-data-v2.vue?vue&type=template&id=2a8d6f03&scoped=true&"
import script from "./goods-data-v2.vue?vue&type=script&lang=js&"
export * from "./goods-data-v2.vue?vue&type=script&lang=js&"
import style0 from "./goods-data-v2.vue?vue&type=style&index=0&id=2a8d6f03&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d6f03",
  null
  
)

export default component.exports